import React from "react";
import { ReactReader } from "react-reader";
import { useParams } from "react-router-dom";
import ScreenLoader from "../components/Skeleton/ScreenLoader";
import { useQuery } from "react-query";
import { API, ebookUrl } from "../config/api";
import Logo from "../components/Logo";

function ReadBook(props) {
  const { id } = useParams();
  // eslint-disable-next-line
  const { isLoading, error, data: book, refetch } = useQuery("getBook", () =>
    API.get(`/book/${id}`)
  );

  return isLoading ? (
    <ScreenLoader />
  ) : (
    <>
      <div className="mt-6 ml-16 mb-4 ">
        <Logo />
      </div>
      <div style={{ height: "90vh", position: "relative" }}>
        <ReactReader
          url={`${ebookUrl}/${book.data.data.file}`}
          title={book.data.data.title}
          location={"epubcfi(/6/2[cover]!/6)"}
        />
      </div>
    </>
  );
}

export default ReadBook;
